<template>
  <teleport to="body">
    <div class="modal fade" :id="id" :aria-labelledby="`${id}-label`" tabindex="-1" aria-hidden="true" :data-bs-backdrop="staticBackdrop ? 'static' : true" data-bs-keyboard="false">
      <div class="modal-dialog" :class="dialogClasses">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header">
              <button type="button" class="btn-modal-close" @click="close">
                <i class="icon-close"></i>
              </button>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              {{ body }}
            </slot>
          </div>

          <!-- Footer -->
          <!-- <div class="modal-footer">
          <slot name="footer">
            <button type="button" class="btn btn-secondary" @click="close">
              Κλείσιμο
            </button>
          </slot>
        </div> -->
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { inject, computed, onMounted, onBeforeUnmount } from 'vue';

const emit = defineEmits(['shown', 'hide', 'hidden']);
const $modal = inject('$modal');

const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, default: '' },
  body: { type: String, default: '' },
  size: { type: String, default: null }, // sm, lg, xl
  centered: { type: Boolean, default: false },
  fullscreen: { type: Boolean, default: false },
  scrollable: { type: Boolean, default: false },
  staticBackdrop: { type: Boolean, default: false }
})

const dialogClasses = computed(() => {
  return [
    props.size ? `modal-${props.size}` : '',
    props.centered ? 'modal-dialog-centered' : '',
    props.fullscreen ? 'modal-fullscreen' : '',
    props.scrollable ? 'modal-dialog-scrollable' : '',
  ]
})

const close = () => {
  $modal.hide(props.id)
}

onMounted(() => {
  $modal.onShown(props.id, () => emit('shown', props.id));
  $modal.onHide(props.id, () => emit('hide', props.id));
  $modal.onHidden(props.id, () => emit('hidden', props.id));
});

</script>

<style lang="scss">
.modal-header {
  justify-content: center;
  position: relative;

  .btn-modal-close {
    font-size: 0;
    color: #fff;
    z-index: 5;
    transition-property: opacity;
    transition-duration: 250ms;
    transition-timing-function: ease-in-out;

    i {
      &::before {
        font-size: 2rem;
      }
    }

    &:hover {
      opacity: 0.5;
    }
  }
}

.modal-body {
  .modal-logo {
    width: 140px;
  }
}
</style>